const paladin = {
	name: 'Paladin',
	role: 'A holy warrior who blends heavy melee combat with divine magic, healing, and party protection. Paladins tank the front line while smiting evil foes and shielding allies with protective auras, making them a durable, self-sufficient melee/support hybrid.',
	alignment: 'Lawful Good',
	hitDie: 'd10',
	startingWealth: '5d6 × 10 gp (average 175 gp)',
	bab: 'Full',
	specialByLevel: [
		'Aura of good, detect evil, smite evil 1/day', // 1
		'Divine grace, lay on hands', // 2
		'Aura of courage, divine health, mercy', // 3
		'Channel positive energy, smite evil 2/day', // 4
		'Divine bond', // 5
		'Mercy', // 6
		'Smite evil 3/day', // 7
		'Aura of resolve', // 8
		'Mercy', // 9
		'Smite evil 4/day', // 10
		'Aura of justice', // 11
		'Mercy', // 12
		'Smite evil 5/day', // 13
		'Aura of faith', // 14
		'Mercy', // 15
		'Smite evil 6/day', // 16
		'Aura of righteousness', // 17
		'Mercy', // 18
		'Smite evil 7/day', // 19
		'Holy champion', // 20
	],
	saves: { fort: 'Good', ref: 'Poor', will: 'Good' },
	classSkills: ['Craft', 'Diplomacy', 'Handle Animal', 'Heal', 'Knowledge (Nobility)', 'Knowledge (Religion)', 'Profession', 'Ride', 'Sense Motive', 'Spellcraft'],
	skillRanksPerLevel: 2,
	keyAbility: 'Strength and Charisma',
	description: 'Paladins are noble souls sworn to hunt down evil wherever it lurks, protecting the innocent and upholding the ideals of law and good. They combine martial prowess with divine power, standing as beacons of justice on the battlefield. A paladin balances devastating offense against evil with healing and protective abilities for allies.',
	spellcasting: {
		type: 'Divine',
		keyAbility: 'Charisma',
		style: 'Prepared',
		description: 'Paladins begin casting a small number of divine spells at 4th level, preparing them after an hour of prayer; their effective caster level equals paladin level minus 3.',
	},
	spellsPerDay: [
		[0, 0, 0, 0], // 1
		[0, 0, 0, 0], // 2
		[0, 0, 0, 0], // 3
		[0, 0, 0, 0], // 4
		[1, 0, 0, 0], // 5
		[1, 0, 0, 0], // 6
		[1, 0, 0, 0], // 7
		[1, 1, 0, 0], // 8
		[2, 1, 0, 0], // 9
		[2, 1, 0, 0], // 10
		[2, 1, 1, 0], // 11
		[2, 2, 1, 0], // 12
		[3, 2, 1, 0], // 13
		[3, 2, 1, 1], // 14
		[3, 2, 2, 1], // 15
		[3, 3, 2, 1], // 16
		[4, 3, 2, 1], // 17
		[4, 3, 2, 2], // 18
		[4, 3, 3, 2], // 19
		[4, 4, 3, 3], // 20
	],
	features: [
		{ level: 1, name: 'Aura of Good', description: 'The paladin radiates a magical aura of good whose power scales with paladin level, as detected by the detect good spell.' },
		{ level: 1, name: 'Detect Evil', description: 'At will, the paladin can concentrate on a single target as a move action to detect evil creatures, objects, or auras within 60 feet.' },
		{ level: 1, name: 'Smite Evil', description: 'Once per day (more often at higher levels, up to 7/day at 19th), the paladin can add her Charisma bonus to an attack roll and her paladin level to damage against a designated evil target, bypassing damage reduction and gaining a deflection bonus to AC against that foe.' },
		{ level: 2, name: 'Divine Grace', description: 'The paladin adds her Charisma bonus to all saving throws.' },
		{ level: 2, name: 'Lay on Hands', description: 'The paladin can heal 1d6 hit points per two paladin levels a number of times per day equal to half her level plus her Charisma modifier, or use the same pool to deal damage to undead with a touch.' },
		{ level: 3, name: 'Aura of Courage', description: 'The paladin is immune to fear effects and grants allies within 10 feet a +4 morale bonus on saving throws against fear while she is conscious.' },
		{ level: 3, name: 'Divine Health', description: 'The paladin is immune to all diseases, including supernatural and magical diseases.' },
		{ level: 3, name: 'Mercy', description: 'Each time the paladin lays on hands, the target also heals one additional affliction (such as a condition or effect); she gains additional mercies at 6th, 9th, 12th, 15th, and 18th level.' },
		{ level: 4, name: 'Channel Positive Energy', description: 'By expending two uses of lay on hands, the paladin can channel positive energy as a cleric of her paladin level, healing allies or harming undead in a burst.' },
		{ level: 4, name: 'Spells', description: 'The paladin begins preparing and casting a small number of divine spells, with her effective caster level equal to her paladin level minus 3.' },
		{ level: 5, name: 'Divine Bond', description: 'The paladin bonds with either a celestial spirit that can temporarily enhance one of her weapons, or a loyal mount that grows in power alongside her, gaining a celestial template at 11th level and spell resistance at 15th.' },
		{ level: 8, name: 'Aura of Resolve', description: 'The paladin is immune to charm effects and grants allies within 10 feet a +4 morale bonus on saving throws against charm while she is conscious.' },
		{ level: 11, name: 'Aura of Justice', description: 'By expending two uses of smite evil, the paladin can grant the smite evil ability to all allies within 10 feet for one minute.' },
		{ level: 14, name: 'Aura of Faith', description: 'The paladin\'s weapon attacks, and the weapon attacks of allies within 10 feet, are treated as good-aligned for the purpose of overcoming damage reduction.' },
		{ level: 17, name: 'Aura of Righteousness', description: 'The paladin gains damage reduction 5/evil, is immune to compulsion effects, and grants allies within 10 feet a +4 morale bonus on saving throws against compulsion while she is conscious.' },
		{ level: 20, name: 'Holy Champion', description: 'The paladin\'s damage reduction improves to 10/evil, her smite evil can banish evil outsiders she strikes, and her channel positive energy and lay on hands always restore the maximum possible amount.' },
	],
};

export default paladin;
